<template>
  <div id="SystemDevelopmentDivision">
    <el-row :gutter="20" class="gutter-bot-10">
      <el-col :span="8">
        <c-block-box title="营收利润指标" class="first-floor-item-1">
          <div
            slot="sub-title"
            id="details-btn"
            class="digital-btn coocaa_btn"
            leftTarget="#details-btn"
            upTarget="#Parlor"
            router="/kanban-config-view?id=8"
            rel="digitalDetails"
            @click="seeDetails('/kanban-config-view?id=79')"
          >
            详情
          </div>
          <el-col :span="12">
            <div class="top-box">
              <div class="top-box--flex">
                <div class="tendency-hd">
                  <div class="tendency-title">总营收（万元）</div>
                </div>
                <div class="value">{{ numberSplitWithComma((dashboard.mediaMonthIncome || 0) * 1) }}</div>
                <div class="tendency">
                  <div class="tendency-text">
                    <span>环比</span>
                    <img :src="upsAndDowns(dashboard.mediaMonthRatio)" />
                    <em>{{ percentage(dashboard.mediaMonthRatio || 0) }}%</em>
                  </div>
                  <div class="tendency-text">
                    <span>同比</span>
                    <img :src="upsAndDowns(dashboard.mediaMonthYRatio)" />
                    <em>{{ percentage(dashboard.mediaMonthYRatio || 0) }}%</em>
                  </div>
                </div>
                <c-target-rate
                  label="完成率"
                  :target="`${getRealData(dashboard.mediaMonthTarget) || 0} 万`"
                  :num="percentage((dashboard.mediaMonthFinishRatio || 0) * 1)"
                  height=".7rem"
                ></c-target-rate>
                <c-target-rate
                  label="匹配度"
                  :num="percentage((dashboard.mediaTargetFinishRatio || 0) * 1)"
                  height=".7rem"
                ></c-target-rate>
              </div>
            </div>
          </el-col>
          <el-col :span="12" class="ys-total">
            <div class="top-box">
              <div class="top-box--flex">
                <div class="tendency-hd">
                  <div class="tendency-title">毛利额（万元）</div>
                </div>
                <div class="value">{{ numberSplitWithComma(getRealDataFix(dashboard.profitAmount) || 0) }}</div>
                <div class="tendency">
                  <div class="tendency-text">
                    <span>环比</span>
                    <img :src="upsAndDowns(dashboard.profitRatio)" />
                    <em>{{ percentage((dashboard.profitRatio || 0) * 1) }}%</em>
                  </div>
                  <div class="tendency-text">
                    <span>同比</span>
                    <img :src="upsAndDowns(dashboard.profitYRatio)" />
                    <em>{{ percentage((dashboard.profitYRatio || 0) * 1) }}%</em>
                  </div>
                </div>
                <c-target-rate
                  label="完成率"
                  :target="`${getRealData(dashboard.profitAmountTarget)} 万`"
                  :num="percentage((dashboard.profitFinishRatio || 0) * 1)"
                  height=".7rem"
                ></c-target-rate>
                <c-target-rate
                  label="匹配度"
                  :num="percentage((dashboard.prifitTargetFinishRatio || 0) * 1)"
                  height=".7rem"
                ></c-target-rate>
              </div>
            </div>
          </el-col>
        </c-block-box>
      </el-col>
      <el-col :span="16">
        <c-block-box title="业务核心指标" class="first-floor-item-2">
          <el-col :span="6" class="ys-total">
            <div class="top-box">
              <div class="top-box--flex">
                <div class="tendency-hd">
                  <div class="tendency-title">新增外部终端数（万台）</div>
                  <router-link
                    tag="div"
                    id="details-btn"
                    class="digital-btn coocaa_btn terimal-btn"
                    to="/SystemDevelopmentDivisionTerimel"
                  >
                    详情
                  </router-link>
                </div>
                <div class="value">{{ numberSplitWithComma(((dashboard.outDeviceAdd/10000) || 0) * 1) }}</div>
                <div class="tendency">
                  <div class="tendency-text">
                    <span>环比</span>
                    <img :src="upsAndDowns(dashboard.outDeviceMonthRatio)" />
                    <em>{{ percentage(dashboard.outDeviceMonthRatio || 0) }}%</em>
                  </div>
                  <div class="tendency-text">
                    <span>同比</span>
                    <img :src="upsAndDowns(dashboard.outDeviceMonthYRatio)" />
                    <em>{{ percentage(dashboard.outDeviceMonthYRatio || 0) }}%</em>
                  </div>
                </div>
                <c-target-rate
                  label="累计外部终端数："
                  :target="`${splitWnumber((dashboard.outDeviceTotal || 0) * 1)} 万`"
                  :is-progress="false"
                  height=".7rem"
                ></c-target-rate>
                <!-- <c-target-rate
                  label="当前占比总体比例："
                  :target="`${dashboard.outDeviceToAllRatio || 0}%`"
                  :is-progress="false"
                  height=".7rem"
                ></c-target-rate> -->
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <ChartPie
              id="account-receivable-ratio"
              height="8.5rem"
              width="100%"
              :option="accountReceivableRatio"
            ></ChartPie>
          </el-col>
          <el-col :span="6" class="top-right-3">
            <div class="box-hd">
              <p>直播付费用户月ARPU值（元）</p>
              <p class="count">
                {{ numberSplitWithComma((dashboard.livePayARPU || 0)) }}
              </p>
            </div>
            <div
              id="details-btn"
              class="digital-btn coocaa_btn"
              leftTarget="#details-btn"
              upTarget="#Parlor"
              router="/kanban-config-view?id=50"
              rel="digitalDetails"
              @click="seeDetails('/kanban-config-view?id=50')"
            >
              详情
            </div>
          </el-col>
          <el-col :span="4" class="top-right-4">
            <div class="box-hd">
              <p>广告日活年ARPU值（元）</p>
              <p class="count">
                {{ numberSplitWithComma((dashboard.adDailyARPU || 0)) }}
              </p>
            </div>
          </el-col>
        </c-block-box>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="second-floor-item">
          <c-block-box title="拓展核心指标" class="second-floor-item-1">
            <div class="tz-wrap">
              <ETable :data="dashboard.indicators"></ETable>
            </div>
          </c-block-box>
          <c-block-box title="营收、成本、投放率分布" class="second-floor-item-2">
            <!-- <div
              slot="sub-title"
              id="closePic"
              class="digital-btn coocaa_btn"
              leftTarget="#closePic"
              upTarget="#DigitalMarketing"
              router="/kanban-config-view?id=53"
              rel="digitalDetails"
              @click="seeDetails('/kanban-config-view?id=53')"
            >
              详情
            </div> -->
            <!-- <echarts-china></echarts-china> -->
            <div style="height:24rem">
              <DistributionRevenueDeliveryRate :distributed-volist="dashboard.distributedVOList"></DistributionRevenueDeliveryRate>
            </div>
          </c-block-box>
        </div>
      </el-col>
      <el-col :span="12">
        <c-block-box title="true" class="second-floor-item">
          <template slot="title">
            <div id="e-tilte-lists">
              <span
                class="title-item"
                :class="{
                  ac:chinaTtitleAc === 0
                }"
                @click="changeChinaTtotle(0)"
              >终端分布(万)</span>
              <span
                class="title-item"
                :class="{
                  ac:chinaTtitleAc === 1
                }"
                @click="changeChinaTtotle(1)"
              >缺量分布(CPM)</span>
            </div>
          </template>
          <echarts-china style="height:34rem" :china-titleac="chinaTtitleAc" :data="dashboard"></echarts-china>
          <!-- <div id="baiduMap" style="height:34rem; width: 100%;"></div> -->
        </c-block-box>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import echartsChina from '@/components/echarts/echartsChina'
import DistributionRevenueDeliveryRate from '@/components/DistributionRevenueDeliveryRate'
import ETable from '@/components/ETable'
import common from '@/mixins/common.js'
import ChartPie from '@/components/echarts/pie'
export default {
  mixins: [common],
  name: 'SystemDevelopmentDivision',
  components: {
    echartsChina,
    ETable,
    DistributionRevenueDeliveryRate,
    ChartPie
  },
  props: {},
  data () {
    let that = this
    return {
      chinaTtitleAc: 0,
      dashboard: {},
      accountReceivableRatio: {
        config: {
          type: 2,
          picRadius: '90%',
          picCenter: ['20%', '50%'],
          tooltip: {
            show: true
          },
          legend: {
            left: '40%',
            y: 'center',
            textStyle: {
              fontSize: 16,
              color: 'white',
              rich: {
                b: {
                  fontSize: 14,
                  color: '#999999'
                }
              }
            },
            formatter: (name, a) => {
              let itemVal = that.accountReceivableRatio.data.find(item => item.name === name)
              let result = null
              if (itemVal) {
                result = `{a|${name}} {b|${itemVal.num}万台} {b|${(itemVal.value).toFixed(2)}%}`
              }
              return result
            }
          }
        },
        data: [
          // { name: '创维终端', value: '78' },
          // { name: '外部终端', value: '22' }
        ]
      },
      // 核心业务指标增长趋势图
      barLine: [],
      // 累计终端数及占比图
      mediaFinancialPieTotal: {
        config: {
          type: 2,
          picRadius: '70%',
          tooltip: {
            show: false
          },
          seriesLabel: {
            show: false
          },
          legend: {
            show: false
          }
        },
        data: []
      }
    }
  },
  computed: {
    getRealData () {
      return (num) => {
        let newNum = Math.round(num / 10000)
        return newNum
      }
    },
    getRealDataFix () {
      return (num) => {
        let newNum = Math.round(num / 100) / 100
        return newNum
      }
    }
  },
  created () {
    this.getProject()
  },
  mounted () {
    // // 百度地图API功能
    // var map = new BMap.Map('baiduMap')
    // map.centerAndZoom(new BMap.Point(120.378386, 30.309756), 6)// 根据坐标初始化地图
    // map.enableScrollWheelZoom(true)
    // // map.addControl(new BMap.NavigationControl()) // 平移缩放控件
    // map.addControl(new BMap.ScaleControl()) // 比例尺
    // // map.addControl(new BMap.OverviewMapControl()) // 缩略地图
    // map.addControl(new BMap.MapTypeControl({
    //   mapTypes: [BMAP_NORMAL_MAP]
    // })) // 地图类型
    // map.addControl(new BMap.CopyrightControl()) // 地图类型
    // map.setCurrentCity('杭州') // 仅当设置城市信息时，MapTypeControl的切换功能才能可用
    // // 添加标注
    // var marker = new BMap.Marker(new BMap.Point(120.378386, 30.309756)) // 创建标注
    // map.addOverlay(marker) // 将标注添加到地图中
  },
  watch: {

  },
  methods: {
    getProject () {
      const yearMonth = JSON.parse(sessionStorage.getItem('toggleDate')).time
      const isAndroid = this.$store.state.app.isAndroid
      this.barLine = []
      this.$service.fetch({
        url: 'api/media/dashboard_new',
        method: 'get',
        params: {
          yearMonth
        }
      }).then(res => {
        this.dashboard = res
        this.accountReceivableRatio.data = res.pieChart.map(item => {
          return {
            name: item.name,
            value: parseFloat((item.value * 100).toFixed(2)),
            num: parseFloat(((item.name.indexOf('创维') >= 0 ? res.skyWorth : res.other) / 10000).toFixed(2))
          }
        })
      })
    },
    changeChinaTtotle (index) {
      this.chinaTtitleAc = index
    }
  }
}
</script>

<style scoped lang="stylus">
#SystemDevelopmentDivision
  flex 1 1

.tz-wrap
  padding 1rem

.top-box
  // height 9.75rem
  display flex
  color rgba(255, 255, 255, 0.8)
  .value
    font-size 2.4rem
    color #fff
    height 3.5rem
    line-height 3.5rem
  .tendency
    display flex
    font-size .7rem
    color rgba(255, 255, 255, 0.8)
    // padding-bottom .5rem
    .tendency-text
      padding-right 1rem
      white-space nowrap
      img
        width .6rem
        vertical-align middle
        margin 0 .2rem
    .tendency-text:last-child
      padding 0
   >>>.c-target-rate
      line-height 1.2rem
      height 1.2rem
      font-size .7rem
      .c-progress
        margin-top .3rem
  .top-box--flex
    flex 1
    padding-left 1rem

.first-floor-item-1,.first-floor-item-2
  >>> .unit-body
        overflow: hidden
        padding-bottom: 1rem
.second-floor-item-1
  margin-bottom: 1rem
.tendency-hd
  padding 1rem 0 0 0

.gutter-bot-10
  margin-bottom: 1rem

.box-hd
  display: flex
  align-items: center
  justify-content: center
  flex-direction: column
  color rgba(255, 255, 255, 0.8)
  font-size: .8rem

.top-right-4,.top-right-3
  display: flex
  height:8rem
  color rgba(255, 255, 255, 0.8)
  padding-top: .5rem
  .count
    font-weight: bolder
    flex-grow: 1
    font-size: 2rem
    align-items: center
    justify-content: center
    display: flex
  #details-btn
    margin-top: 0

#baiduMap
  height: 400px

#e-tilte-lists
  color: #999
  .title-item
    cursor pointer
  .title-item+.title-item
    margin-left: 20px
  .title-item.ac
    color: #fff

.tendency-hd
  display: flex
  align-items: center

.digital-btn.terimal-btn
  padding: .1rem 0.5rem;
  width: auto;
  text-align: center;
  height: auto;
  line-height: normal;
  margin-top: 0;
  font-size: .2rem
</style>
